import { render } from "./OnlineSignature.vue?vue&type=template&id=ddaa9a46"
import script from "./OnlineSignature.vue?vue&type=script&lang=js"
export * from "./OnlineSignature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__